import currentRoute from './currentRoute';
import { resolveDynamicOption } from './utils';
import type { RouteConfigExtended } from './types';

export const currentRouteLabel = (routes: RouteConfigExtended[]) =>
    resolveDynamicOption(currentRoute(routes)?.label);
